import { useEffect, useState } from "react";

const useCountdown = (endDate) => {
  const countdownDate = new Date(endDate).getTime();

  const [remainingTime, setRemainingTime] = useState(countdownDate - new Date().getTime());

  const getReturnValues = (remainingTime) => {
    // calculate time left
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    // to not display negative values
    if (days + hours + minutes + seconds <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return { days, hours, minutes, seconds };
  };

  useEffect(() => {
    // callback fn inside setInterval() will be called every second
    const intervalId = setInterval(() => {
      setRemainingTime(countdownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [countdownDate]);

  return getReturnValues(remainingTime);
};

export default useCountdown;
